import React from "react";
import Logo from "../components/Logo";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { VilleLogo } from "../components/Variables-en";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaRegEnvelope } from "react-icons/fa";

export default class NavBootstrap extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggled: false };
    this.handler = this.handler.bind(this);
    this.handlerSubMenu = this.handlerSubMenu.bind(this);
  }

  handler() {
    this.setState((prevState) => ({
      toggled: !prevState.toggled,
    }));
    if (this.state.active === true) {
      this.setState({ active: false });
    }
  }

  // for the opérations submeny
  handlerSubMenu() {
    this.setState((prevState) => ({
      active: !prevState.active,
    }));
  }

  render() {
    return (
      <NavWrapper className="fixed-top">
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container>
            <Navbar.Brand href="/en/">
              {" "}
              <Logo />
              Créateurs d'intérieur <VilleLogo />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto w-100">
                <Nav.Link href="/" className="mobile-only">
                  Home
                </Nav.Link>
                <NavDropdown
                  title="Expertise"
                  id="basic-nav-dropdown"
                  css={css`
                    @media (max-width: 768px) {
                      padding-top: 8px;
                    }
                  `}
                >
                  <NavDropdown.Item href="/en/interior-designer/">
                    Interior designer
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/interior-decorator/">
                    Interior decorator
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/architect/">
                    Architect
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/landscape-designer/">
                    Landscape designer
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Services" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/en/home-pre-purchase-advice/">
                    Home pre-purchase advice
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/off-plan-homes-consultancy/">
                    Off plan home design consultancy
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/interior-makeover/">
                    Interior makeover
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/energy-efficient-home-remodelling/">
                    Energy-efficient home remodelling
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/house-extension/">
                    House extension / elevation
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/disability-friendly-interior-design/">
                    Disability-friendly Interior Design
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/commercial-architecture/">
                    Commercial architecture
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/en/office-space-design/">
                    Corporate architecture
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="/en/projects/">Projects</Nav.Link>
                <Nav.Link href="/en/before-after/">Before & After</Nav.Link>
                <Nav.Link href="/en/about-us/">About us</Nav.Link>
                <Nav.Link href="/en/prices/">Prices</Nav.Link>
                <Nav.Link
                  href="/en/contact-us/"
                  className="nav-button nav-button-en"
                >
                  <FaRegEnvelope
                    css={css`
                      font-size: 17px;
                      font-weight: 300;
                      margin-right: 8px;
                      margin-top: -5px;
                    `}
                  />
                  Contact us
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </NavWrapper>
    );
  }
}

const NavWrapper = styled.div`
  background-color: white !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.098);
`;
